// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_task__c25SU {
  padding: 5px 10px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: center;
  opacity: 0.25;
}
.style_task__active__TPaoG {
  background: rgb(255, 255, 255);
  color: rgb(27, 27, 27);
  opacity: 1;
}
.style_task__active__special__i6Sk5 {
  border-color: #ffcd2f;
}
.style_task__completed__3QAYE {
  padding: 6px 11px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  opacity: 1;
}
.style_task__next__qZf44 {
  opacity: 0.5;
}
.style_task__next__active__UXfvc {
  opacity: 1;
}
.style_task__next__special__RqCwS {
  border: 1px solid #ffcd2f;
}
.style_task__content__OJ-Ok {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.style_task__content__day__GDxdz {
  font-weight: 600;
  color: rgb(27, 27, 27);
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  gap: 4px;
}
.style_task__content__day__GDxdz i {
  color: #ffcd2f;
  font-size: 1.2rem;
}
.style_task__content__amount__3btoF {
  display: flex;
  gap: 4px;
  align-items: center;
}
.style_task__content__amount__3btoF img {
  width: 12px;
  height: 12px;
}
.style_task__content__amount__3btoF p {
  font-size: 1.2rem;
  font-weight: 600;
}
.style_task__claimed__hUoso {
  display: flex;
  gap: 4px;
}
.style_task__claimed__icon__1Tkcm {
  color: rgb(0, 255, 98);
  font-size: 1.4rem;
}
.style_task__claimed__title__h9FAE {
  opacity: 0.5;
  font-weight: 600;
  font-size: 1.4rem;
  color: rgb(28, 25, 46);
}
.style_task__default__dMkev {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
}
.style_task__default__day__OmM5o {
  font-weight: 600;
  color: rgb(255, 255, 255);
  font-size: 1.4rem;
}
.style_task__default__day__OmM5o i {
  color: #ffcd2f;
  font-size: 1.2rem;
}
.style_task__default__amount__tn5wK {
  display: flex;
  gap: 4px;
  align-items: center;
}
.style_task__default__amount__tn5wK img {
  width: 12px;
  height: 12px;
}
.style_task__default__amount__tn5wK p {
  font-size: 1.2rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/earn/tasks/%D1%81uberium-daily-streak/cuberium-daily-task/style.module.scss","webpack://./src/pages/earn/tasks/сuberium-daily-streak/cuberium-daily-task/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;ACDF;ADIE;EACE,8BETI;EFUJ,sBEbU;EFcV,UAAA;ACFJ;ADGI;EACE,qBAAA;ACDN;ADKE;EACE,iBAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;ACHJ;ADME;EACE,YAAA;ACJJ;ADOE;EACE,UAAA;ACLJ;ADQE;EACE,yBAAA;ACNJ;ADSE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;ACPJ;ADQI;EACE,gBAAA;EACA,sBE/CQ;EFgDR,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ACNN;ADOM;EACE,cAAA;EACA,iBAAA;ACLR;ADSI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ACPN;ADQM;EACE,WAAA;EACA,YAAA;ACNR;ADQM;EACE,iBAAA;EACA,gBAAA;ACNR;ADWE;EACE,aAAA;EACA,QAAA;ACTJ;ADUI;EACE,sBAAA;EACA,iBAAA;ACRN;ADUI;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACRN;ADYE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,QAAA;ACVJ;ADWI;EACE,gBAAA;EACA,yBE5FE;EF6FF,iBAAA;ACTN;ADUM;EACE,cAAA;EACA,iBAAA;ACRR;ADYI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ACVN;ADWM;EACE,WAAA;EACA,YAAA;ACTR;ADWM;EACE,iBAAA;EACA,gBAAA;ACTR","sourcesContent":["@import 'public/assets/colors';\n\n.task {\n  padding: 5px 10px;\n  border: 1px solid $white;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  justify-content: center;\n  opacity: 0.25;\n  // height: 100%;\n\n  &__active {\n    background: $white;\n    color: $black-extra;\n    opacity: 1;\n    &__special {\n      border-color: #ffcd2f;\n    }\n  }\n\n  &__completed {\n    padding: 6px 11px;\n    border: none;\n    background: rgba(255, 255, 255, 0.25);\n    opacity: 1;\n  }\n\n  &__next {\n    opacity: 0.5;\n  }\n\n  &__next__active {\n    opacity: 1;\n  }\n\n  &__next__special {\n    border: 1px solid #ffcd2f;\n  }\n\n  &__content {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n    &__day {\n      font-weight: 600;\n      color: $black-extra;\n      font-size: 1.4rem;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      i {\n        color: #ffcd2f;\n        font-size: 1.2rem;\n      }\n    }\n\n    &__amount {\n      display: flex;\n      gap: 4px;\n      align-items: center;\n      img {\n        width: 12px;\n        height: 12px;\n      }\n      p {\n        font-size: 1.2rem;\n        font-weight: 600;\n      }\n    }\n  }\n\n  &__claimed {\n    display: flex;\n    gap: 4px;\n    &__icon {\n      color: rgba(0, 255, 98, 1);\n      font-size: 1.4rem;\n    }\n    &__title {\n      opacity: 0.5;\n      font-weight: 600;\n      font-size: 1.4rem;\n      color: rgba(28, 25, 46, 1);\n    }\n  }\n\n  &__default {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2px;\n    &__day {\n      font-weight: 600;\n      color: $white;\n      font-size: 1.4rem;\n      i {\n        color: #ffcd2f;\n        font-size: 1.2rem;\n      }\n    }\n\n    &__amount {\n      display: flex;\n      gap: 4px;\n      align-items: center;\n      img {\n        width: 12px;\n        height: 12px;\n      }\n      p {\n        font-size: 1.2rem;\n        font-weight: 600;\n      }\n    }\n  }\n}\n",".task {\n  padding: 5px 10px;\n  border: 1px solid rgb(255, 255, 255);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  justify-content: center;\n  opacity: 0.25;\n}\n.task__active {\n  background: rgb(255, 255, 255);\n  color: rgb(27, 27, 27);\n  opacity: 1;\n}\n.task__active__special {\n  border-color: #ffcd2f;\n}\n.task__completed {\n  padding: 6px 11px;\n  border: none;\n  background: rgba(255, 255, 255, 0.25);\n  opacity: 1;\n}\n.task__next {\n  opacity: 0.5;\n}\n.task__next__active {\n  opacity: 1;\n}\n.task__next__special {\n  border: 1px solid #ffcd2f;\n}\n.task__content {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n.task__content__day {\n  font-weight: 600;\n  color: rgb(27, 27, 27);\n  font-size: 1.4rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.task__content__day i {\n  color: #ffcd2f;\n  font-size: 1.2rem;\n}\n.task__content__amount {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.task__content__amount img {\n  width: 12px;\n  height: 12px;\n}\n.task__content__amount p {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n.task__claimed {\n  display: flex;\n  gap: 4px;\n}\n.task__claimed__icon {\n  color: rgb(0, 255, 98);\n  font-size: 1.4rem;\n}\n.task__claimed__title {\n  opacity: 0.5;\n  font-weight: 600;\n  font-size: 1.4rem;\n  color: rgb(28, 25, 46);\n}\n.task__default {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n}\n.task__default__day {\n  font-weight: 600;\n  color: rgb(255, 255, 255);\n  font-size: 1.4rem;\n}\n.task__default__day i {\n  color: #ffcd2f;\n  font-size: 1.2rem;\n}\n.task__default__amount {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n.task__default__amount img {\n  width: 12px;\n  height: 12px;\n}\n.task__default__amount p {\n  font-size: 1.2rem;\n  font-weight: 600;\n}","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"task": `style_task__c25SU`,
	"task__active": `style_task__active__TPaoG`,
	"task__active__special": `style_task__active__special__i6Sk5`,
	"task__completed": `style_task__completed__3QAYE`,
	"task__next": `style_task__next__qZf44`,
	"task__next__active": `style_task__next__active__UXfvc`,
	"task__next__special": `style_task__next__special__RqCwS`,
	"task__content": `style_task__content__OJ-Ok`,
	"task__content__day": `style_task__content__day__GDxdz`,
	"task__content__amount": `style_task__content__amount__3btoF`,
	"task__claimed": `style_task__claimed__hUoso`,
	"task__claimed__icon": `style_task__claimed__icon__1Tkcm`,
	"task__claimed__title": `style_task__claimed__title__h9FAE`,
	"task__default": `style_task__default__dMkev`,
	"task__default__day": `style_task__default__day__OmM5o`,
	"task__default__amount": `style_task__default__amount__tn5wK`
};
export default ___CSS_LOADER_EXPORT___;
